import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Side ikke fundet | Hovendals"
        description="Siden blev ikke fundet. Gå til forsiden eller kontakt Hovendals."
      />

      <section className="py-24 md:py-32 bg-slate-50 min-h-[60vh] flex items-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <div className="text-[#004fa4] font-extrabold text-7xl">404</div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Side ikke fundet
          </h1>

          <p className="text-base text-slate-600 max-w-md mx-auto leading-relaxed">
            Siden du leder efter findes desværre ikke eller er blevet flyttet.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm shadow-sm transition-all"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
